class SulwhasooAccordion extends HTMLElement {
    constructor() {
        super();


        const titleText = this.getAttribute("title");


        this.innerHTML = `
        <div class="accordion-tit">${titleText}</div>
        <div class="accordion-content">${this.innerHTML}</div>
      `;

        this.titleElement = this.querySelector(".accordion-tit");
        this.contentElement = this.querySelector(".accordion-content");

        this.contentElement.classList.add("open");
        this.titleElement.classList.add("open");

        this.titleElement.addEventListener("click", () => {
            this.contentElement.classList.toggle("open");
            this.titleElement.classList.toggle("open");
        });
    }
}

customElements.define("sws-pdp-accordion", SulwhasooAccordion);

// function adjustSwiperHeightToActiveSlide() {

//     const swiper = document.querySelector('.accordion-cont-inner .swiper-wrapper');
//     const activeSlide = document.querySelector('.accordion-cont-inner .swiper-slide.sul-slide-item.swiper-slide-active');

//     if (swiper && activeSlide) {
//         swiper.style.height = '100%';
//         const contentHeight = activeSlide.offsetHeight;
//         swiper.style.height = contentHeight + 'px';
//     }
// }

// 초기 호출
// adjustSwiperHeightToActiveSlide();

class SwiperCarousel extends HTMLElement {
    constructor() {
        super();
        this.style.display = 'block';
        // if (this.querySelector('.swiper .swiper-wrapper').childElementCount === 1) return;
        this.swiper = null;
        this._createCarousel();
    }

    get carouselConfig() {
        return (this.dataset.config) ? JSON.parse(this.dataset.config) : {};
    }
    get carouselInstance() {
        return this.swiper;
    }
    _createCarousel(config = null, event = null) {
        const currentConfig = this.carouselConfig;
        const _config = {
            slidesPerView : 1,
            spaceBetween: 0,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    console.log(className);
                    console.log('index', index);
                    return `<span class="${className}" data-index="${index}">${(Array(2).join('0') + (index+1)).slice(-2)}</span>`
                },
            },
            // on: {
            //     setTransition: function () {
            //         adjustSwiperHeightToActiveSlide();
            //     },
            // },
            ...config,
            ...currentConfig,
        };
        // console.log(currentConfig)

        this.swiper = new Swiper(this.querySelector('.swiper'), {..._config});
    }
}
customElements.define("swiper-carousel", SwiperCarousel);

class ColorSwatches extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSwatches();
    }

    initSwatches() {
        const colorSwatches = this.querySelectorAll(".color-chip");
        const mainImage = document.getElementById("main-image");
        const secondaryImage = document.getElementById("secondary-image");
        const thirdImage = document.getElementById("third-image");
        const colorName = document.querySelector(".prd-color #color-name");

        if (!mainImage || !colorName) return;

        colorSwatches.forEach(swatch => {
            swatch.addEventListener("click", (event) => {
                event.preventDefault();


                const listItems = this.querySelectorAll(".color-chip-list li");
                listItems.forEach(li => li.classList.remove("on"));
                swatch.parentElement.classList.add("on");


                if (swatch.dataset.imgItem1) {
                    mainImage.src = swatch.dataset.imgItem1;
                    mainImage.alt = swatch.dataset.altItem1 || "";
                }


                if (secondaryImage) {
                    if (swatch.dataset.imgItem2) {
                        secondaryImage.src = swatch.dataset.imgItem2;
                        secondaryImage.alt = swatch.dataset.altItem2 || "";
                        secondaryImage.style.display = "block";
                    } else {
                        secondaryImage.style.display = "none";
                    }
                }

                if (thirdImage) {
                    if (swatch.dataset.imgItem3) {
                        thirdImage.src = swatch.dataset.imgItem3;
                        thirdImage.alt = swatch.dataset.imgItem3 || "";
                        thirdImage.style.display = "block";
                    } else {
                        thirdImage.style.display = "none";
                    }
                }


                if (swatch.dataset.colorName) {
                    colorName.textContent = swatch.dataset.colorName;
                }
            });
        });
    }
}
// customElements.define("color-swatches", ColorSwatches);

class SizeSelector extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        setTimeout(() => {
            this.initSizeOptions();
        }, 0);
    }

    initSizeOptions() {
        const sizeOptions = this.querySelectorAll(".btn-measure");

        sizeOptions.forEach(size => {
            if (size.classList.contains("disabled")) {
                size.style.pointerEvents = "none";
                size.style.filter = "grayscale(100%)";
                size.style.opacity = "1";
                size.style.cursor = "not-allowed";
            } else {
                size.addEventListener("click", (event) => {
                    event.preventDefault();

                    sizeOptions.forEach(option => option.classList.remove("active"));


                    if (!size.classList.contains("disabled")) {
                        size.classList.add("active");

                        const variantId = size.dataset.variantId;
                        if (variantId) {
                            const newUrl = new URL(window.location.href);
                            newUrl.searchParams.set("variant", variantId);
                            window.location.href = newUrl.toString();
                        }
                    }
                });
            }
        });
    }
}
// customElements.define("size-selector", SizeSelector);